import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { FichaDespesaService } from "contabil-lib";
import { BaseResourceRptComponent, Coluna, Exercicio, ExercicioService, FavorecidoService, FichaDespesa } from "eddydata-lib";
import { MenuItem } from "primeng/api";
import { takeUntil } from "rxjs/operators";
import * as toastr from 'toastr';

@Component({
  selector: 'lib-favorecido-pf-rpt',
  templateUrl: './favorecido-pf-rpt.component.html',
  styleUrls: ['./favorecido-pf-rpt.component.css']
})
export class favorecidoPessoaFisicaRptComponent extends BaseResourceRptComponent {

  public ordernacao: { nome: string, coluna: string, ordem: 'DESC' | 'ASC' };
  public listaOrdenacao: { nome: string, coluna: string, ordem: 'DESC' | 'ASC' }[] = [];
  public listaExercicios: Array<Exercicio>;
  public exercicioSelect: Exercicio;

  public listaFiltros: Coluna[] = [];
  public menuFiltros: MenuItem[] = [];
  public apenasEmpenhados: boolean = false;
  public porFichaDespesa: boolean = false;
  public lista: FichaDespesa[] = [];
  public selecionados: FichaDespesa[] = [];

  protected datepipe: DatePipe;

  constructor(
    private favorecidoService: FavorecidoService,
    protected exercicioService: ExercicioService,
    protected fichaDespesaService: FichaDespesaService,
  ) {
    super();
    this.exercicioSelect = this.login.exercicio;
  }

  protected afterInit(): void {
    this.datepipe = new DatePipe('pt');
    this.orientacao = "landscape";
    this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaExercicios = dados.content;
      });
    this.fichaDespesaService.filtrar(1, -1, { 'exercicio.id': this.login.exercicio.id, 'orgao.id': this.login.orgao.id, relations: 'despesa', orderBy: 'numero' }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content
      });
  }

  protected tituloRelatorio(): string {
    return `Fornecedores Pessoa Física`;
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Nome', coluna: 'nome', tipo: 'String' });
    retorno.push({ titulo: 'CPF', coluna: 'cpf_cnpj', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'Rua', coluna: 'endereco', tipo: 'String', });
    retorno.push({ titulo: 'Número', coluna: 'num_endereco', tipo: 'String' });
    retorno.push({ titulo: 'Bairro', coluna: 'bairro', tipo: 'String' });
    retorno.push({ titulo: 'Cidade', coluna: 'municipio', tipo: 'String' });
    retorno.push({ titulo: 'Estado', coluna: 'uf', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'CEP', coluna: 'cep', alignment: 'center', tipo: 'String' });
    retorno.push({ titulo: 'E-mail', coluna: 'email', tipo: 'String', fontSize: 8 });
    retorno.push({ titulo: 'Telefone', coluna: 'telefone', tipo: 'String', fontSize: 8 });
    return retorno;
  }

  protected larguraColunas(): (string | number)[] {
    return ['*', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
  }

  protected totalizarColunas(): (string | {})[] {
    return undefined;
  }

  protected carregarLista(): Promise<any[]> {
    let parametros = {
      'tipo.tce': '02',
      'orderBy': `nome`
    };
    if (this.apenasEmpenhados || this.porFichaDespesa) {
      parametros['empenhos.orgao.id'] = this.login.orgao.id
    }
    if (this.apenasEmpenhados) {
      parametros['empenhos.exercicio.id'] = this.exercicioSelect.id;
    }
    if (this.porFichaDespesa && this.selecionados.length) {
      const ids = this.selecionados.slice(0, 1000).map(item => item.id).join(',');
      parametros['empenhos.ficha.id$in'] = `${ids}`
    }
    if (this.porFichaDespesa && !this.selecionados.length) {
      toastr.info('Selecione pelo menos uma ficha de despesa!')
      return;
    } else {
      return new Promise((resolve) => {
        this.favorecidoService.filtrar(1, -1, parametros).pipe(takeUntil(this.unsubscribe))
          .subscribe(async (res) => {
            if (!res?.content?.length) {
              resolve([])
            } else {
              res.content.forEach(f => {
                f.cep = this.funcaoService.mascarar('00.000-000', f.cep)
              })
              let lista = res.content;
              resolve(lista);
            }
          });
      })
    }

  }

  protected mensagemVazio(): string {
    return 'Nenhum registro encontrado!';
  }

  // protected layout(): {} {
  //   return {
  //     hLineWidth() {
  //       return 1;
  //     },
  //     vLineWidth() {
  //       return 1;
  //     },
  //     hLineColor(i) {
  //       return i === 1 || i === 0 ? 'black' : '#aaa';
  //     },
  //     paddingLeft(i) {
  //       return i === 0 ? 0 : 3;
  //     },
  //     paddingRight(i, node) {
  //       return (i === node.table.widths.length - 1) ? 0 : 3;
  //     }
  //   }
  // }

  verificarFiltros(empenhados: boolean) {
    // if (empenhados) {
    //   this.porFichaDespesa = false;
    //   this.selecionados = [];
    // } else {
    //   this.apenasEmpenhados = false;
    // }
  }

  carregarFichas() {
    this.fichaDespesaService.filtrar(1, -1, { 'exercicio.id': this.exercicioSelect.id, 'orgao.id': this.login.orgao.id, relations: 'despesa', orderBy: 'numero' }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content
      });
  }

  public todosSelecionados(): boolean {
    const listaSemAutorizados = this.lista.filter((ficha) => {
      return true;
    })
    return !listaSemAutorizados ? true : listaSemAutorizados.filter((l) => this.validSelect(l)).length === listaSemAutorizados.length;
  }

  public validSelect(ficha: FichaDespesa) {
    const sel = this.selecionados.find((s) => s.id === ficha.id);
    return !(!sel)
  }

  public selecionarTodos() {
    let todosSel = this.todosSelecionados();
    let lista: any[] = [];
    if (this.lista) {
      this.lista.forEach((l) => {
        if (!todosSel && !this.validSelect(l)) {
          this.selecionar(l, true);
          lista.push(l);
        } else if (todosSel && this.validSelect(l))
          this.selecionar(l, false);
      });
    }
  }

  public selecionar(ficha: FichaDespesa, select: boolean) {
    if (select) {
      this.selecionados.push(ficha);
      this.selecionados.sort((a, b) => +a.numero - +b.numero);
    }
    else
      this.selecionados = this.selecionados.filter((s) => s.id !== ficha.id);
  }

}
